import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

export const noAuthGuard: CanActivateFn = () => {
  const userService = inject(AuthService);
  const router = inject(Router);

  if (userService.isAuthenticated()) {
    return router.createUrlTree(['/']);
  }

  return true;
};
